import { Box, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";

import { INK } from "../../../theme/tokens";

type Props = {
	label: string;
	value: ReactNode;
};

/**
 * Small key/value display used in raw-data / integration detail views.
 * Renders a muted label above its value, falling back to "--" for empty values.
 * Sizing is driven entirely by the parent grid/flex container.
 */
export const LabeledField: FC<Props> = ({ label, value }) => (
	<Box sx={{ display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
		<Typography sx={{ fontSize: "12px", color: INK.MUTED, fontWeight: 500 }}>{label}</Typography>
		<Typography sx={{ fontSize: "14px", color: INK.SECONDARY, fontWeight: 600, wordBreak: "break-word" }}>
			{value === null || value === undefined || value === "" ? "--" : value}
		</Typography>
	</Box>
);
